import React from "react";
import { ComponentExt } from "@src/utils/reactExt";
import { createForm } from 'rc-form';
class Gift extends ComponentExt<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            info: '',
            color: '',
            success: false,
            remainingCycle: '',
            resDetailRecord: []
        }
    }

    componentDidMount() {
        location.href = 'weixin://dl/business/?appid=wxc8eb807ef794c210&path=pages/index/index'
    }

    render(): React.ReactNode {
        return (
            <div></div>
        )
    }
}
export default createForm()(Gift)